import { FC, useMemo, useState } from "react"

import ReservationCartArticle from "models/ReservationCartArticle"
import InvoicePositionTextModal from "components/InvoicePositionTextModal/InvoicePositionTextModal"
import ReservationArticle from "models/ReservationArticle"
import { InsertConfigurationModal } from "components/InvoicePositionTextModal/InsertConfigurationModal"
import { Purpose, TextVariableGroup } from "config/constants"
import { Guid } from "@/types"
import useConfigurationText from "hooks/useConfigurationText"
import ReservationCartAsset from "models/ReservationCartAsset"
import ReservationAsset from "models/ReservationAsset"

interface IReservationInvoicePositionTextModalProps {
    text?: string
    articles?: ReservationCartArticle[] | ReservationArticle[]
    reservationLanguage?: string
    purpose?: Purpose | null
    onSave?(text: string): Promise<void> | void
    onClose(): void
}

const ReservationInvoicePositionTextModal: FC<IReservationInvoicePositionTextModalProps> = ({
    text: initialText,
    articles,
    reservationLanguage,
    onSave,
    onClose,
    purpose,
}) => {
    const [text, setText] = useState(initialText || "")
    const { getConfigurationText } = useConfigurationText()
    const [showInsertConfigurationModal, setShowInsertConfigurationModal] = useState(false)

    const configurationData = useMemo(() => {
        return articles?.map((item) => ({
            articleId: item.articleId,
            articleNumber: item.articleNo,
            articleDescription: item.articleDescription,
            assetsCount: item.assets.length
        })) ?? []
    }, [articles])

    function onInsertConfiguration({ mergeAssets, printFeatures }: { mergeAssets: Record<Guid, boolean>, printFeatures: Record<Guid, boolean> }) {
        if (!articles) return

        setText(getConfigurationText({
            mergeAssets,
            printFeatures,
            language: reservationLanguage,
            articles: articles.map((article: ReservationCartArticle | ReservationArticle) => ({
                articleId: article.articleId,
                articleDescriptionTranslations: article.articleDescriptionTranslations ?? {},
                articleFeatures: article.articleFeatures,
                assets: article.assets.map((asset: ReservationCartAsset | ReservationAsset) => ({
                    assetId: asset.assetId,
                    isFixed: asset.isFixed,
                    lmid: asset.lmid,
                    serialNumber: asset.serialNumber,
                    assetFeatures: asset.features
                }))
            }))
        }))
    }

    return (
        <>
            <InvoicePositionTextModal
                isAdd={!initialText}
                text={text}
                setText={setText}
                onInsertConfiguration={articles ? () => setShowInsertConfigurationModal(true) : undefined}
                onSave={onSave}
                onClose={onClose}
                textVariableGroup={TextVariableGroup.withInvoiceCounterRequest}
            />

            {showInsertConfigurationModal &&
                <InsertConfigurationModal
                    articles={configurationData}
                    purpose={purpose}
                    onClose={() => { setShowInsertConfigurationModal(false) }}
                    onSave={onInsertConfiguration}
                />
            }
        </>
    )
}

export default ReservationInvoicePositionTextModal
